import { useState, useEffect } from 'react';

import { findParcelsByOrder, parcelFeathersService } from '../../../feathers/services/Parcel.service';
import { ParcelDetailed, Order } from '../../../feathers/server-interface';

const useFetchParcelsByOrder = (orderId: string) => {
  const [parcels, setParcels] = useState<ParcelDetailed[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>();

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      try {
        const fetchedOrderParcels = await findParcelsByOrder(orderId);
        setParcels(fetchedOrderParcels); 
      } catch (error: any) {
        setError(error.message);
      }
      setIsLoading(false);
    }
    init();
  }, [orderId]);

  useEffect(() => {
    const handleParcelCreate = (createdParcel: ParcelDetailed) => {
      if ((createdParcel.order as Order)?._id === createdParcel._id) {
        setParcels((prevState: ParcelDetailed[]) => {
          return [createdParcel, ...prevState];
        });
      }
    };

    const handleParcelPatch = (patchedParcel: ParcelDetailed) => {
      if ((patchedParcel.order as Order)?._id === patchedParcel._id) {
        setParcels((prevState: ParcelDetailed[]) => prevState.map((prevParcel) => {
          if (prevParcel._id === patchedParcel._id) return patchedParcel;
          return prevParcel;
        }));
      }
    };

    parcelFeathersService.on('created', handleParcelCreate);
    parcelFeathersService.on('patched', handleParcelPatch);

    return () => {
      parcelFeathersService.removeListener('created', handleParcelCreate);
      parcelFeathersService.removeListener('patched', handleParcelPatch);
    }
  }, []);

  return {
    parcels,
    isLoading,
    error,
  };
};

export default useFetchParcelsByOrder;